var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-banner flex align-center justify-center"},[_c('img',{attrs:{"src":_vm.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.button)?_c('a',{staticClass:"button ghost white",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.button))]):_vm._e()])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ece2450","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/utils/FooterBanner.vue
// module id = z3m2
// module chunks = 0